const styles = {
	mainContent: {
		width: '100%',
	},
	container: {
		width: '65%',
		maxWidth: 850,
		margin: '0 auto',
		'@media (max-width: 750px)': {
			width: '96.3%',
		},
		'@media (max-width: 375px)': {
			width: '90%',
		},
	},
	wrapper: {
		width: '100%',
		fontSize: 16,
		fontWeight: 400,
		lineHeight: '24px',
		paddingBottom: 40,
		color: '#000',
		textAlign: 'left',
	},
	sectionTitle: {
		fontSize: 32,
		fontWeight: 400,
		lineHeight: '32px',
		marginBottom: 30,
		'@media (max-width: 750)': {
			fontsize: 24,
			marginbottom: 20,
		},
	},
	list: {
		listStyle: 'disc',
	},
}

export default styles
